export default "__VITE_ASSET__PzdKl7o___"